
export default {
  name: '',
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    handleBrTag(content) {
      if (!content) {
        return '';
      }
      return content.replace(/\n/gm,"<br/>")
    },
    handleBrArr(content) {
      if (!content) {
        return '';
      }
      return content.split(/[\n]/);
    },
  }
};



// WEBPACK FOOTER //
// ./src/mixins/index.js